import { StringKey } from '../../../../../../../lang/index';

export enum ApproveHurdleColumn {
  APPROVAL_DATE = 'approval-date',
  CURRENT_VALUATION = 'current-valuation',
  GRANT = 'grant',
  HURDLE = 'hurdle',
  ISSUED_SHARES = 'issued-shares',
  SELECT = 'select',
  SHARE_CLASS = 'share-class',
  STAKEHOLDER = 'stakeholder',
}

export const approveHurdleColumnTranslationKey: Record<ApproveHurdleColumn, StringKey> = {
  [ApproveHurdleColumn.STAKEHOLDER]: 'STAKEHOLDER',
  [ApproveHurdleColumn.GRANT]: 'GRANT',
  [ApproveHurdleColumn.APPROVAL_DATE]: 'APPROVAL_DATE',
  [ApproveHurdleColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [ApproveHurdleColumn.HURDLE]: 'HURDLE',
  [ApproveHurdleColumn.CURRENT_VALUATION]: 'CURRENT_VALUATION',
  [ApproveHurdleColumn.ISSUED_SHARES]: 'ISSUED_SHARES',
  [ApproveHurdleColumn.SELECT]: 'EMPTY',
};

export const approveHurdleColumnMap = Object.keys(approveHurdleColumnTranslationKey);
